/* global gtag */
export class Ga4Transformer {
    constructor(measurementId, googleAdsId = false, getCurrentLocation = () => window.location.href) {
        this.measurementId = measurementId;
        this.googleAdsId = googleAdsId;
        this.getCurrentLocation = getCurrentLocation;
    }

    isApplicable() {
        return typeof gtag !== 'undefined';
    }

    transform(url) {
        if (!this.isApplicable()) {
            return Promise.resolve(url);
        }

        return new Promise((resolve) => {
            const valuesToResolve = [
                this.getClientId(),
                this.getSessionId(),
            ];

            if (this.googleAdsId) {
                valuesToResolve.push(this.getGoogleAdsId());
            }

            Promise.all(valuesToResolve).then(([ clientId, sessionId, googleAdsId ]) => {
                if (!clientId) {
                    resolve(url);
                }

                const params = {
                    client_id: clientId,
                };

                if (sessionId) {
                    params.session_id = sessionId;
                }

                if (googleAdsId) {
                    params.gclid = googleAdsId;
                }

                const urlWithParams = new URL(url);

                Object.keys(params).forEach(key => {
                    urlWithParams.searchParams.append(key, params[key]);
                });

                resolve(urlWithParams.toString());
            }).catch((reason) => {
                console.warn('Could not retrieve GA4 values', reason);
                resolve(url);
            });
        });
    }

    getSessionId() {
        return this.getGtagValue('session_id');
    }

    getClientId() {
        return this.getGtagValue('client_id');
    }

    getGoogleAdsId() {
        const url = this.getCurrentLocation();
        const gclidOriginUrl = new URL(url);
        const gclidFromUrl = gclidOriginUrl.searchParams.get('gclid');

        if (!!gclidFromUrl) {
            return Promise.resolve(gclidFromUrl);
        }

        return this.getGtagValue('gclid', this.googleAdsId);
    }

    getGtagValue(key, gtagId = null) {
        return new Promise(resolve => {
            const timerId = setTimeout(() => {
                console.log(`GA4 value "${key}" retrievel failed due to timeout`);
                resolve(null);
            }, 50);

            gtag('get', (gtagId || this.measurementId), key, (args) => {
                clearTimeout(timerId);
                resolve(args);
            });
        });
    }
}
